// 51黑料 - 单页首页静态内容与封面素材（全部为演示数据）

export const SECTIONS = [
  { id: "top", label: "封面头条" },
  { id: "rank", label: "热度榜" },
  { id: "feed", label: "线报速递" },
  { id: "topics", label: "话题墙" },
  { id: "fields", label: "分区密档" },
  { id: "guide", label: "投稿密报" },
];

// 压顶更新条滚动文案
export const stockLine = [
  "【线报速递】某新能源车企渠道补贴政策被曝外泄，多地经销商连夜调整报价",
  "【密报】头部直播机构选品内审名单流出，涉及高毛利美妆类目",
  "【投稿】互联网大厂末位淘汰名单风波，内部邮件截图待核实",
  "【线人】一线城市学区房成交价异动，中介渠道统计遭泄露",
  "【独家】多品牌酸奶新国标送检结果对比，配料表差异引热议",
  "【线报】某共享办公平台拖欠供应商款项，多城工区被贴催缴函",
  "【密报】连锁餐饮后厨巡检暗访视频，涉食品安全批次引关注",
];

// 首页头条标签
export const heroTags = [
  { label: "独家线报", count: "12" },
  { label: "平台黑幕", count: "86" },
  { label: "职场密档", count: "203" },
  { label: "消费维权", count: "58" },
  { label: "内部密报", count: "34" },
];

// 封面配图池（杂志风抽象封面，墨色+报章红）
export const covers = [
  "https://readdy.ai/api/search-image?query=Dark%20editorial%20magazine%20cover%20art%2C%20near-black%20ink%20background%20with%20bold%20crimson%20red%20abstract%20burst%20of%20fractured%20shards%20radiating%20from%20center%2C%20dramatic%20directional%20lighting%2C%20high%20contrast%2C%20mysterious%20investigative%20intelligence%20spy%20mood%2C%20matte%20cinematic%20grain%20texture%2C%20premium%20newsprint%20aesthetic%2C%20generous%20dark%20negative%20space%2C%20no%20text%2C%20no%20letters%2C%20no%20numbers&width=900&height=1200&seq=cover-01&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Dark%20editorial%20magazine%20cover%20art%2C%20deep%20ink%20black%20with%20sweeping%20vermilion%20orange%20geometric%20ribbons%20layered%20in%20motion%2C%20fierce%20contrast%2C%20cinematic%20rim%20light%2C%20covert%20intelligence%20dossier%20mood%2C%20matte%20film%20grain%2C%20bold%20print%20composition%2C%20dark%20negative%20space%20for%20headline%2C%20no%20text%2C%20no%20letters%2C%20no%20numbers&width=900&height=1200&seq=cover-02&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Dark%20editorial%20magazine%20cover%20art%2C%20near-black%20charcoal%20background%20with%20crimson%20red%20concentric%20rings%20and%20sharp%20diagonal%20beams%20of%20light%2C%20tense%20surveillance%20spy%20aesthetic%2C%20high%20key%20contrast%20lighting%2C%20cinematic%20grain%20texture%2C%20modern%20investigative%20journalism%20look%2C%20moody%20dark%20space%20above%2C%20no%20text%2C%20no%20letters%2C%20no%20numbers&width=900&height=1200&seq=cover-03&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Dark%20editorial%20magazine%20cover%20art%2C%20ink%20black%20surface%20with%20shattered%20glass%20crack%20lines%20glowing%20crimson%20and%20embers%2C%20secret%20leak%20documents%20aesthetic%2C%20dramatic%20single%20source%20light%2C%20high%20contrast%20shadow%20play%2C%20matte%20grain%2C%20covert%20operation%20intelligence%20mood%2C%20dark%20negative%20space%2C%20no%20text%2C%20no%20letters%2C%20no%20numbers&width=900&height=1200&seq=cover-04&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Dark%20editorial%20magazine%20cover%20art%2C%20charcoal%20ink%20with%20geometric%20hexagon%20grid%20in%20vermilion%20orange%20and%20crimson%20accent%20lines%2C%20network%20intelligence%20hive%20aesthetic%2C%20precise%20lighting%20contrast%2C%20matte%20cinematic%20grain%2C%20digital%20espionage%20report%20mood%2C%20clean%20dark%20upper%20space%2C%20no%20text%2C%20no%20letters%2C%20no%20numbers&width=900&height=1200&seq=cover-05&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Dark%20editorial%20magazine%20cover%20art%2C%20near-black%20ink%20with%20torn%20paper%20strata%20edges%20revealing%20crimson%20red%20underlayer%2C%20secret%20file%20dossier%20mood%2C%20dramatic%20chiaroscuro%20lighting%2C%20matte%20film%20grain%2C%20investigative%20newspaper%20aesthetic%2C%20ample%20dark%20negative%20space%2C%20no%20text%2C%20no%20letters%2C%20no%20numbers&width=900&height=1200&seq=cover-06&orientation=portrait",
];

// 首页大幅主封面
export const heroCover =
  "https://readdy.ai/api/search-image?query=Dark%20dramatic%20editorial%20magazine%20cover%20art%2C%20near-black%20ink%20with%20crimson%20red%20and%20vermilion%20abstract%20ink%20plume%20erupting%20from%20bottom%20corner%2C%20bold%20geometric%20sweeps%20and%20fine%20grain%2C%20high%20contrast%20single%20source%20spotlight%2C%20covert%20intelligence%20dossier%20mood%2C%20matte%20cinematic%20texture%2C%20premium%20news%20print%20composition%2C%20generous%20dark%20negative%20space%20in%20upper%20two%20thirds%2C%20no%20text%2C%20no%20letters%2C%20no%20numbers&width=1280&height=1440&seq=hero-cover&orientation=portrait";

// 热度榜
export const rankList = [
  { no: "01", title: "车企补贴政策渠道外泄，多地报价连夜改", cat: "财经密报", heat: 98241, trend: "+32%" },
  { no: "02", title: "头部MCN选品内审名单流出，涉高毛利美妆", cat: "直播线报", heat: 87453, trend: "+28%" },
  { no: "03", title: "大厂“末位优化”名单风波，内部邮件待核实", cat: "职场密档", heat: 79102, trend: "+19%" },
  { no: "04", title: "一线学区房成交异动，中介渠道统计外泄", cat: "房市线报", heat: 66020, trend: "+41%" },
  { no: "05", title: "连锁餐饮后厨暗访批次曝光，监管介入", cat: "消费维权", heat: 55890, trend: "+12%" },
  { no: "06", title: "新锐茶饮加盟纠纷激增，合同条款被逐条扒出", cat: "平台黑幕", heat: 49807, trend: "+9%" },
];

// 线报速递（短讯流）
export const flashItems = [
  { id: "A1", tag: "独家", tone: "primary", title: "某共享办公巨头连续三期拖欠供应商结算款，多城工区遭催缴函集中曝光。", time: "08:42", src: "线人 匿名" },
  { id: "A2", tag: "财经", tone: "accent", title: "头部券商研报“内部提示函”流传，涉某消费电子供应链库存高企疑云。", time: "08:15", src: "投稿 内部" },
  { id: "A3", tag: "职场", tone: "secondary", title: "互联网大厂薪酬结构调整细节流出，多位主管被约谈，评论区已炸。", time: "07:58", src: "线报 员工" },
  { id: "A4", tag: "消费", tone: "primary", title: "多款网红无糖饮料配料实测结果对比，代糖剂量差异引发复测呼声。", time: "07:36", src: "投稿 商家" },
  { id: "A5", tag: "娱乐", tone: "accent", title: "头部主播年框报价单疑泄露，坑位费与保量比例引同行侧目。", time: "07:10", src: "线人 圈内" },
  { id: "A6", tag: "地产", tone: "secondary", title: "某二线城市土拍内部测算表外流，新房备案价松动信号被放大解读。", time: "06:47", src: "密报 渠道" },
  { id: "A7", tag: "独家", tone: "primary", title: "连锁咖啡品牌供应链抽检结果分批流出，涉部分批次原料批次编号。", time: "06:22", src: "投稿 供货" },
  { id: "A8", tag: "财经", tone: "accent", title: "平台二季度补贴预算方案疑遭提前披露，商家端消息群已传开。", time: "06:01", src: "线报 商家" },
];

// 话题墙
export const hotTopics = [
  { label: "补贴外泄", heat: "98K" },
  { label: "选品名单", heat: "87K" },
  { label: "末位优化", heat: "79K" },
  { label: "后厨暗访", heat: "66K" },
  { label: "渠道串货", heat: "54K" },
  { label: "加盟维权", heat: "49K" },
  { label: "薪酬内幕", heat: "47K" },
  { label: "报价单", heat: "43K" },
  { label: "检测超标", heat: "38K" },
  { label: "样品复测", heat: "34K" },
  { label: "底薪结构", heat: "31K" },
  { label: "备案价", heat: "29K" },
  { label: "坑位费", heat: "26K" },
  { label: "抽检批次", heat: "22K" },
  { label: "催缴函", heat: "19K" },
  { label: "内部邮件", heat: "17K" },
  { label: "配货比例", heat: "15K" },
  { label: "巡检表", heat: "13K" },
  { label: "结算账期", heat: "11K" },
  { label: "供货单", heat: "9.8K" },
];

// 分区密档（封面网格）
export const fields = [
  { key: "jobs", kicker: "职场密档", name: "内幕 · 优化名单 · 薪酬结构", desc: "汇集大厂人事动态、组织调整与员工匿名线报。", cover: 0, items: ["某厂外包转正名额骤减", "部门撤并内部信流出", "年度调薪幅度测算表"] },
  { key: "market", kicker: "平台黑幕", name: "运营规则 · 商家博弈 · 灰产", desc: "平台补贴、流量分配、结算账期的一手变化与反常识观察。", cover: 1, items: ["二季度补贴方案提前披露", "新商家冷启动扶持缩水", "供应链账期一拖再拖"] },
  { key: "shop", kicker: "消费维权", name: "质检 · 批次 · 食安追踪", desc: "送检对比、批次抽检与维权进度实时同步。", cover: 2, items: ["无糖饮料代糖剂量复测", "连锁餐饮后厨暗访跟进", "跨境童装重金属送检"] },
  { key: "estate", kicker: "房市密报", name: "备案价 · 成交异动 · 土拍", desc: "中介渠道统计与内部测算带来的市场信号。", cover: 3, items: ["学区房成交价异动明细", "土拍内部测算表外流", "新盘渠道费上调传闻"] },
  { key: "live", kicker: "直播线报", name: "坑位费 · 选品 · 榜一大战", desc: "MCN、主播与供应链的报价与谈单细节。", cover: 4, items: ["头部主播年框报价单", "选品内审名单流出", "投流投放预算对比"] },
  { key: "car", kicker: "财经密报", name: "车企 · 渠道 · 政策套利", desc: "补贴、渠道与价格政策变动的一手线报。", cover: 5, items: ["新能源补贴渠道外泄", "经销商报价连夜调整", "保险返点比例变化"] },
];

// 投稿通道
export const submitChannels = [
  { icon: "ri-mail-send-line", name: "邮箱投稿", desc: "图文、文档、邮件截图均可，建议附时间戳与来源说明。" },
  { icon: "ri-shield-user-line", name: "匿名密报", desc: "不记录账号与设备指纹，端到端加密接收，身份完全脱敏。" },
  { icon: "ri-voiceprint-line", name: "语音线人", desc: "不方便打字可录音投稿，转写后人工核验归类并归档。" },
  { icon: "ri-folder-lock-line", name: "机密附件", desc: "合同、邮件、报表等保密文件，单次加密链接限时读取。" },
];

// 投稿/密报引导步骤
export const guideSteps = [
  { no: "01", title: "整理素材", desc: "把线索整理成时间线：何时、何地、何人与关键数字，佐证越充分越易优先核实。" },
  { no: "02", title: "选择通道", desc: "邮箱、匿名密报或语音线人任一通道均可，建议保留可二次核实的原始留痕。" },
  { no: "03", title: "人工核验", desc: "编辑组交叉核验来源与信息链，去重归类后进入选题池，不实信息自动弃用。" },
  { no: "04", title: "发布与回执", desc: "被采纳线索将打码后上线并标注贡献，通过预留通道回执采纳结果与热度。" },
];

// 投稿FAQ
export const faqs = [
  { q: "投稿会被溯源到个人吗？", a: "不会。匿名密报通道不记录账号与设备指纹，所有素材经脱敏处理后再进入选题与发布流程。" },
  { q: "什么样的素材更容易被采纳？", a: "越接近一手的时间、地点、主体与关键数字越好。附带可交叉验证的截图、文件或录音线索会优先排期核实。" },
  { q: "提供密报后我可以撤回吗？", a: "在人工核验完成前可通过原回执通道申请撤回。一旦进入发布流程，为保护线人匿名性不再单独撤单。" },
  { q: "不实的投稿会怎么处理？", a: "无法通过交叉验证的投稿会被标注“存疑”或直接弃用，不会进入正式发布，也请勿以投稿方式散播失实内容。" },
];

// 页脚栏目（仅锚点跳转，单页无独立页）
export const footerCols = [
  { title: "线索分类", links: ["职场密档", "平台黑幕", "消费维权", "房市密报", "财经密报"] },
  { title: "投稿通道", links: ["邮箱投稿", "匿名密报", "语音线人", "机密附件"] },
  { title: "关于本站", links: ["核验标准", "线人保护", "免责声明", "联系方式"] },
];